var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3C7.8056 3 4.00002 6.80558 4.00002 11.5C4.00002 13.3106 4.56503 14.9863 5.52839 16.3642C5.65702 16.5482 5.72 16.7701 5.70721 16.9942C5.67939 17.4813 5.61054 18.0464 5.4806 18.6961C5.34675 19.3654 5.17843 19.9417 4.99863 20.4321L8.84213 19.4072C9.04566 19.3529 9.26113 19.3643 9.45781 19.4397C10.401 19.8013 11.4262 20 12.5 20C17.1944 20 21 16.1944 21 11.5C21 6.80558 17.1944 3 12.5 3ZM2.28337 21.3026C2.28497 21.3008 2.28815 21.2973 2.2928 21.292C2.30653 21.2764 2.3331 21.2451 2.36973 21.1972C2.44292 21.1015 2.55663 20.939 2.68837 20.7019C2.95112 20.2289 3.28993 19.4515 3.51944 18.3039C3.60229 17.8896 3.65453 17.5251 3.6852 17.2072C2.61921 15.5638 2.00002 13.6029 2.00002 11.5C2.00002 5.70101 6.70103 1 12.5 1C18.299 1 23 5.70101 23 11.5C23 17.299 18.299 22 12.5 22C11.2942 22 10.1339 21.7963 9.05302 21.4208L3.25769 22.9662C2.82058 23.0828 2.35966 22.8914 2.1337 22.4995C1.91001 22.1115 1.97175 21.6227 2.28337 21.3026Z",
    fill: "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms3);
export default __webpack_public_path__ + "static/media/sms-3.175aa8497ea8defe528ca87a2618ca6f.svg";
export { ForwardRef as ReactComponent };